import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { RouteMetadata } from '../../shared/models/route.model';
import { RouteService } from '../../shared/services/route.service';
import { RouteSectionTableComponent } from './components/route-section-table/route-section-table.component';

@Component({
  selector: 'app-routes-page',
  imports: [
    CommonModule,
    CardModule,
    TranslateModule,
    ToastModule,
    TableModule,
    ButtonModule,
    ConfirmDialogModule,
    RouteSectionTableComponent,
  ],
  providers: [
    MessageService,
    RouteService,
    ConfirmationService,
    TranslateService,
  ],
  templateUrl: './routes-page.component.html',
  styleUrl: './routes-page.component.scss',
})
export class RoutesPageComponent implements OnInit {
  routeService = inject(RouteService);

  public routeColumns = RouteMetadata.routeColumns;
  public globalFilterFields = RouteMetadata.globalFilterFields;

  ngOnInit(): void {
    this.routeService.getRoutes();
  }

  onSectionChanged() {
    this.routeService.getRoutes();
  }
}
